import useSWR from 'swr';
import Globals from '../models/strapi/Globals';

const fetcher = (url: string) => fetch(url).then((res) => res.json());
export const useGlobals = (locale: string): Globals | null => {
	const { data } = useSWR<Globals>(`/api/globals/${locale}`, fetcher);
	return data !== null ? new Globals(data) : null;
};
